module.exports = __webpack_public_path__ + "static/media/tooltip-icon.48e68f97.svg";